require('../../modules/es7.object.values');
module.exports = require('../../modules/$.core').Object.values;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/object/values.js
// module id = 1028
// module chunks = 2